module.exports = __webpack_public_path__ + "static/media/fvs_valve1_119.3c55a81f.jpg";